// Pricing & packages - migrated from www.pieinthesky.co.za/videographer-cape-town-prices
// Plus expanded retainer options for hospitality / industry-specific tiers

export const RETAINER_PACKAGES = [
  {
    id: "sky-starter",
    name: "Sky Starter",
    price: 7500,
    priceLabel: "R7,500",
    period: "per month",
    minimum: "3-month minimum",
    headline: "Kickstart your content engine.",
    blurb: "Perfect for small businesses and startups. Steady social media + basic marketing content.",
    features: [
      "10 hours videography, photography & post-production",
      "Monthly goal-setting strategy meeting",
      "Ideal for social media content",
      "Senior crew, cinema-grade kit",
      "In-house finishing",
    ],
    featured: false,
    cta: "Get started",
  },
  {
    id: "cloud-creator",
    name: "Cloud Creator",
    price: 12000,
    priceLabel: "R12,000",
    period: "per month",
    minimum: "3-month minimum",
    headline: "Build brand awareness, every month.",
    blurb: "Growing businesses & marketing teams that need engaging content consistently.",
    features: [
      "20 hours videography, photography & post-production",
      "Monthly goal-setting strategy meeting",
      "Suitable for growing brands",
      "Multi-platform content packages",
      "Senior crew + creative direction",
    ],
    featured: true,
    badge: "Most popular",
    cta: "Choose Cloud Creator",
  },
  {
    id: "horizon-pro",
    name: "Horizon Pro",
    price: 18000,
    priceLabel: "R18,000",
    period: "per month",
    minimum: "3-month minimum",
    headline: "Premium content for established brands.",
    blurb: "For established businesses and agencies running high-end marketing content.",
    features: [
      "30 hours videography, photography & post-production",
      "Monthly goal-setting strategy meeting",
      "2 individual creative sessions per month",
      "High-end content + advanced marketing",
      "Priority scheduling & turnaround",
    ],
    featured: false,
    cta: "Go Horizon Pro",
  },
  {
    id: "infinity-premium",
    name: "Infinity Premium",
    price: 22000,
    priceLabel: "R22,000",
    period: "per month",
    minimum: "3-month minimum",
    headline: "Enterprise-grade visual storytelling.",
    blurb: "Tailored for large businesses and enterprises with complex content needs.",
    features: [
      "40 hours videography, photography & post-production",
      "Monthly goal-setting strategy meeting",
      "2 individual creative sessions per month",
      "Complex, high-quality content production",
      "Dedicated senior producer",
      "Multi-stakeholder approval workflows",
    ],
    featured: false,
    cta: "Talk to us",
  },
];

export const PRICING_FAQS = [
  {
    q: "Can I commit for longer than 3 months?",
    a: "Yes - 6-month and 12-month commitments unlock additional discount tiers (5% off 6 months, 10% off 12 months). Talk to us for tailored pricing.",
  },
  {
    q: "What if I need more hours one month?",
    a: "Additional hours can be added at your retainer hourly rate (lower than ad-hoc pricing). Unused hours don't roll over but we plan production calendars so you never waste them.",
  },
  {
    q: "What does 'hours' include?",
    a: "Crew time on set + post-production. Pre-production (concepts, scripts, briefs) is included in your monthly goal-setting meeting. Travel beyond Cape Town is billed at cost.",
  },
  {
    q: "Do I own the content?",
    a: "Yes - full rights transfer to you on delivery. Raw rushes are archived for 12 months and available on request.",
  },
  {
    q: "Can I pause my retainer?",
    a: "After the initial 3-month minimum you can pause with 30 days' notice. We'll bank your remaining hours for 60 days.",
  },
  {
    q: "What if I just need a one-off project?",
    a: "We do one-off projects too - fill in the project enquiry form below and we'll send a custom quote within one business day.",
  },
];

export const ONE_OFF_PROJECT_TYPES = [
  "Brand film",
  "TV commercial / TVC",
  "Digital ad / paid social",
  "Corporate video",
  "Event coverage",
  "Documentary",
  "Music video",
  "Photography",
  "Other",
];
